import React from 'react';
import MainLayout from 'features/shared/layouts/main';
import { Redirect } from 'react-router-dom';
import useUserData from 'hooks/useUserData';

const HomePage = () => {
  const userData = useUserData();
  return (
    <MainLayout>
      <Redirect to="/main" />
    </MainLayout>
  );
};

export default HomePage;
